import { createAsyncThunk } from '@reduxjs/toolkit';
import { _userUrls } from '@custom/Utils/constants/apiUrls';

interface ActivateUserArgs {
    userId: string;
}

interface ActivateUserResponse {
    status: string;
    result: any;
    msg?: string;
}

const activateUserApi = createAsyncThunk<ActivateUserResponse, ActivateUserArgs>(
    'activateUserApi',
    async ({ userId }) => {
        const token = sessionStorage.getItem('token') || localStorage.getItem('token');
        try {
            const url = `${_userUrls.activateUser}/${userId}`;
            const response = await fetch(url, {
                method: 'PUT',
                headers: {
                    Authorization: 'Bearer ' + token,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({}),
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            return await response.json();
        } catch (error) {
            return Promise.reject(error);
        }
    }
);

export default activateUserApi;
